import { ActivatedRoute, RouterModule } from '@angular/router';
import { ChangeDetectorRef, Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { SiteConfigStore } from '@program-suite/data-common';
import { SpinnerStore } from '@program-suite/data-common';
import { LoadingSpinnerComponent } from '../../components/loading-spinner/loading-spinner.component';
import { BannerComponent } from "../../components/banner/banner.component";
import { LoggedOutStore } from './data/logged-out.store';

@Component({
  selector: 'lib-logged-out',
  imports: [CommonModule, RouterModule, HeaderComponent, FooterComponent, LoadingSpinnerComponent, BannerComponent],
  templateUrl: './logged-out.component.html',
  styleUrl: './logged-out.component.scss',
})
export class LoggedOutComponent{
  siteConfigStore = inject(SiteConfigStore);
  spinnerStore = inject(SpinnerStore);
  loggedOutStore = inject(LoggedOutStore)
  siteName = this.siteConfigStore.siteConfig()?.name ?? '';
  logo = this.siteConfigStore.siteConfig()?.logoUrl ?? '/assets/branding/shasta-logo.png';
  backgroundColor = '';
  private cd = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      const newColor = this.loggedOutStore.backgroundColor() ?? '';
      this.backgroundColor = newColor;
      this.cd.detectChanges();
    });
  }
}
